import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeft20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.9697 3.46967L13.0303 4.53033L7.56065 10L13.0303 15.4697L11.9697 16.5303L5.43933 10L11.9697 3.46967Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeft20.displayName = 'ChevronLeft20';
export default ChevronLeft20;
